var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.5V10.5M2.25 10.5V2.25M2.25 10.5H5.25M2.25 2.25V1.5M2.25 2.25H11.25C12.0784 2.25 12.75 2.92157 12.75 3.75V5.25M12.75 5.25H14.25C15.0784 5.25 15.75 5.92157 15.75 6.75V12.75C15.75 13.5784 15.0784 14.25 14.25 14.25H6.75C5.92157 14.25 5.25 13.5784 5.25 12.75V10.5M12.75 5.25V9C12.75 9.82843 12.0784 10.5 11.25 10.5H5.25",
    stroke: "#ED1C24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOutline);
export default __webpack_public_path__ + "static/media/flag-outline.a2599315c9c95e15f641ce95c4346f42.svg";
export { ForwardRef as ReactComponent };